import {Box} from '@mui/material';

import {culturalAlignmentColors} from '../WorkforceProfileDetail.colors';

import {alignmentStatus} from '../../../../../../layouts/theme/designSystem';
import {COMPANY_MARKER_COLOR} from '../../../utils/WorkforceProfileDetail/workforceCulturalAlignmentUtils';

const legendBadgeStyles = (markerColor: string) =>
  markerColor === COMPANY_MARKER_COLOR
    ? {bgcolor: alignmentStatus.metChipBg, color: alignmentStatus.metChipFg}
    : {bgcolor: culturalAlignmentColors.badge.different.bgcolor, color: culturalAlignmentColors.badge.different.color};

export interface Props {
  color: string;
  label: string;
}

export const WorkforceCulturalAlignmentLegendBadge = ({color, label}: Props) => {
  const badgeStyle = legendBadgeStyles(color);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        fontSize: 12,
        px: 1.25,
        py: 0.375,
        borderRadius: '20px',
        bgcolor: badgeStyle.bgcolor,
        color: badgeStyle.color,
        fontWeight: 500,
      }}
    >
      <Box sx={{width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0}} />
      {label}
    </Box>
  );
};
